import React from "react";
import InfoBox from "./info-box/InfoBox";

const Info = ({ children, headerProps, loading=false, childrenProps, ...rest }) => {
  return (
    <InfoBox
      headerProps={{
        ...headerProps,
        style: {
          backgroundColor: "#EAEDF5",
          color: "#111",
          ...headerProps?.style,
        },
      }}
      childrenProps={{
        ...childrenProps,
        style: { padding: "1rem", ...childrenProps?.style },
      }}
      {...rest}
      style={{ width: "100%", ...rest?.style }}
      loading={loading}
    >
      {children}
    </InfoBox>
  );
};

export default Info;
